import { createContext, useContext, type ReactNode } from 'react';

export type NotifyTone = 'success' | 'error' | 'warning' | 'info';

export interface Notice {
  tone: NotifyTone;
  title: string;
  description?: string;
}

/** Quem mostra o toast. A casca liga no Toaster (sonner) de `shared/ui`; os testes usam um espião. */
export interface Notifier {
  notify(notice: Notice): void;
}

const devNotifier: Notifier = {
  notify(notice) {
    if (import.meta.env.DEV) console.info(`[notifier:${notice.tone}]`, notice.title, notice.description ?? '');
  },
};

const NotifierContext = createContext<Notifier>(devNotifier);

/** Injeta o notifier (valor estável: crie fora do render). */
export function NotifierProvider({ notifier, children }: { notifier: Notifier; children: ReactNode }) {
  return <NotifierContext value={notifier}>{children}</NotifierContext>;
}

export function useNotifier(): Notifier {
  return useContext(NotifierContext);
}
